module.exports = __webpack_public_path__ + "static/img/7.7ecc42f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/7.jpg
// module id = U3z7
// module chunks = 1